<nx-pageTitle-box
  class="mb-3"
  [label]="'rentModule.assignment.taskAssignmentComponent.pageTitle.label' | translate"
  [icon]="'icon-taskplanner'"
  [iconToolTip]="'rentModule.assignment.taskAssignmentComponent.pageTitle.tooltip' | translate">
  <ng-template nxTemplate="end">
    <app-date-selector
      [stateKey]="'taskAssignment'"
      [storageType]="'session'"
      class="date-selector"
      className="white"
      [displayLabel]=false
      (date)="dateChanged($event)">
    </app-date-selector>
  </ng-template>
</nx-pageTitle-box>
<p-tabView
  (onChange)="onTabChange($event)"
  [activeIndex]="activeIndex"
  [scrollable]="true">

  <p-tabPanel [header]="'rentModule.assignment.taskAssignmentComponent.tabs.open' | translate">
    <ng-template pTemplate="content">
      <app-task-assignment-list-unassigned
        [date]="selectedDate"
        [locations]="selectedLocations">
      </app-task-assignment-list-unassigned>
    </ng-template>
  </p-tabPanel>

  <p-tabPanel [header]="'rentModule.assignment.taskAssignmentComponent.tabs.assigned' | translate">
    <ng-template pTemplate="content">
      <app-task-assignment-list-assigned
        [date]="selectedDate"
        [locations]="selectedLocations">
      </app-task-assignment-list-assigned>
    </ng-template>
  </p-tabPanel>

  <p-tabPanel [header]="'rentModule.assignment.taskAssignmentComponent.tabs.completed' | translate">
    <ng-template pTemplate="content">
      <app-task-assignment-list-completed
        [date]="selectedDate"
        [locations]="selectedLocations">
      </app-task-assignment-list-completed>
    </ng-template>
  </p-tabPanel>

</p-tabView>
